/**
 * Las dos familias del sistema — decidido el 2026-09-09 con el handoff de diseño.
 *
 * > [!danger] Autoalojadas, NO pedidas a Google
 * > Hasta hoy las tres SPA las cargaban desde `fonts.googleapis.com`. Eso son
 * > **dos resoluciones DNS y dos conexiones TLS a un tercero** antes de que se
 * > lea una palabra, en el peor sitio posible: el móvil de alguien sentado en
 * > una terraza con datos móviles.
 * >
 * > Y añade un modo de fallo que no controlamos. El menú público es lo que ve un
 * > cliente de nuestro cliente: no puede depender de que un servicio ajeno
 * > responda.
 *
 * > [!info] Karla es una sola fuente para los cuatro pesos
 * > Medido el 2026-09-09: los archivos que Google devuelve para 400, 500, 600 y
 * > 700 son **idénticos byte a byte** — sirve la variable en los cuatro casos.
 * > Guardar los cuatro eran 95 KB del mismo archivo. Con la variable, 23.7 KB.
 *
 * Sólo el subconjunto **latino**, que cubre acentos, ñ, ¿ y ¡. Total: 38 KB.
 */

/* Titulares. Llega tarde sin bloquear nada: mientras tanto se lee en la serif
   del sistema, que es lo que `swap` hace. */
@font-face {
  font-family: 'Instrument Serif';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('../tipografias/instrument-serif-400.woff2') format('woff2');
}

/* Cuerpo. Ésta sí importa: lleva los nombres de los platillos y los precios. */
@font-face {
  font-family: 'Karla';
  font-style: normal;
  font-weight: 400 700;
  font-display: swap;
  src: url('../tipografias/karla-variable.woff2') format('woff2');
}

/* Las familias se NOMBRAN en `tokens.css`, con `--fuente-ui` y `--fuente-marca`,
   que es el vocabulario que ya usaban los componentes desde agosto. Aquí sólo
   viven los archivos. Un segundo juego de variables para lo mismo es la forma
   más segura de que un día se cambie uno y no el otro. */
